import { FileExtended } from "services/api/uploads/types";
import { Upload as FleetDocumentUpload } from "services/api/uploads/types";

export interface TenantAddress {
  id?: string | null;
  city: string | null;
  country: string | null;
  line1: string | null;
  line2: string | null;
  postalCode: string | null;
  state: string | null;
  description: string | null;
  latitude: number | null;
  longitude: number | null;
}

export interface Tenant {
  id: string;
  tenantType: TenantType;
  companyName: string;
  firstName: string;
  lastName: string;
  headquartersAddress: string;
  address: TenantAddress | null;
  phoneNumber: string;
  mobilePhoneNumber: string;
  email: string;
  web: string;
  personalIdentificationNumber: string;
  transactionAccountNumber: string;
  timezone: string;
  logoUpload: LogoDocumentUpload;
  bankAccounts: TenantBankAccount[];
}

export interface TenantBankAccount {
  id: string;
  iban: string;
  bankName: string | null;
  description: string | null;
  primary: boolean;
}

export interface TenantBankAccountEditFormValues {
  iban: string;
  bankName: string | null;
  description: string | null;
  primary: boolean;
}

export interface LogoDocumentUpload {
  id: string;
  originalFileName: string;
  fileExtension: string;
  fileSizeKb: number;
  contentType: string;
  created: Date;
  url: string;
}

export interface TenantEditFormValues {
  id?: string | null;
  tenantTypeId: string | null;
  companyName: string | null;
  firstName: string | null;
  lastName: string | null;
  headquartersAddress: string | null;
  address: TenantAddress | null;
  phoneNumber: string | null;
  mobilePhoneNumber: string | null;
  email: string | null;
  web: string | null;
  personalIdentificationNumber: string | null;
  transactionAccountNumber: string | null;
  timezone: string | null;
  logo: FileExtended[];
}

export interface TenantType {
  id: string;
  name: string;
}

export interface Timezone {
  id: string;
  name: string;
}

/*---------------------------------------------------------------
   TENANT EVENT TYPE
  ---------------------------------------------------------------*/
export enum TenantEventType {
  DETAIL = "DETAIL",
}

/*---------------------------------------------------------------
   TENANT - SEARCH
  ---------------------------------------------------------------*/

export interface TenantRow {
  id: string;
  tenantType: TenantType | null;
  name: string | null;
  companyName: string | null;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  personalIdentificationNumber: string | null;
}

export interface TenantSearchFormValues {
  search: string | null;
}

/*---------------------------------------------------------------
   TENANT - CREATE (wizard step 1)
  ---------------------------------------------------------------*/

export interface TenantCreateFormValues {
  id?: string | null;
  tenantTypeId: string | null;
  companyName: string | null;
  firstName: string | null;
  lastName: string | null;
  headquartersAddress: string | null;
  address: TenantAddress | null;
  phoneNumber: string | null;
  mobilePhoneNumber: string | null;
  email: string | null;
  web: string | null;
  personalIdentificationNumber: string | null;
  timezone: string | null;
  logo: FleetDocumentUpload[];
}

/*---------------------------------------------------------------
   TENANT - USER (wizard step 2)
  ---------------------------------------------------------------*/

export interface TenantUserFormValues {
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  password: string | null;
  confirmPassword: string | null;
  roleId: string | null;
}

export interface TenantUserRow {
  id: string;
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  roles: TenantRole[];
}

export interface TenantRole {
  id: string;
  name: string;
  isAdmin: boolean;
  isSystem: boolean;
}


/** Zauzeće diska tenanta (aktivno + stvarno na disku). */
export interface TenantStorage {
  tenantId: string;
  activeKb: number;
  activeFiles: number;
  totalKb: number;
  totalFiles: number;
}
